import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  useDisclosure,
  Flex,
  Avatar,
  Stack,
  Text,
  Divider,
  MenuItem,
} from "@chakra-ui/react";
import { GrFormCheckmark, GrFormClose } from "react-icons/gr";
import dayjs from "dayjs";

export const GuestDetailsModal = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      {/*<Box alignSelf="flex-end">
        <BiDotsVerticalRounded size="1.5rem" onClick={onOpen} />
  </Box>*/}
      <MenuItem onClick={onOpen}>View Details</MenuItem>

      <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Box my="30px">
              <Flex align="center">
                
                  <Avatar name={props.name} size="lg" />
                

                <Stack pl="10px">
                  <Text color="#9A82B8" fontSize="lg">
                    {props.name}
                  </Text>
                  <Text color="#9A82B8" fontSize="md">
                    {props.phone}
                  </Text>
                  <Flex>
                    <Text color="#FEE8E7" fontSize="x-small">
                      Created:
                    </Text>
                    <Text color="#B7B6B6" fontSize="x-small" pl="5px">
                      {dayjs(props.createdAt).format("DD/MMM/YYYY") }
                    </Text>
                    <Text color="#FEE8E7" fontSize="x-small" pl="5px">
                      Updated
                    </Text>
                    <Text color="#B7B6B6" fontSize="x-small" pl="5px">
                    {dayjs(props.updateAt).format("DD/MMM/YYYY") }
                    </Text>
                  </Flex>
                  <Divider orientation="horizontal" color="#FAF6FF" />
                </Stack>
              </Flex>
              <Box bg="#F9F9F9" p="5" borderRadius="lg" my="40px">
                <Flex justify="space-between">
                  <Stack>
                    <Text color="#7A7A7A" fontSize="sm">
                      Start date
                    </Text>
                    <Text color="#9A82B8" fontSize="md">
                    {dayjs(props.startDate).format("DD/MM/YYYY") }
                    </Text>
                  </Stack>

                  <Stack>
                    <Text color="#7A7A7A" fontSize="sm">
                      end date
                    </Text>
                    <Text color="#9A82B8" fontSize="md">
                    {dayjs(props.endDate).format("DD/MM/YYYY") }
                    </Text>
                  </Stack>

                  <Stack>
                    <Text color="#7A7A7A" fontSize="sm">
                      Status
                    </Text>
                    <Text
                      color="#F98B88"
                      fontSize="xs"
                      bg="#FAF6FF"
                      borderRadius="full"
                      p="3px 12px"
                    >
                    {props.status}
                    </Text>
                  </Stack>
                </Flex>

                <Flex justify="space-between" align="center" py="20px">
                  <Stack>
                    <Text color="#7A7A7A" fontSize="sm">
                      Guest Code
                    </Text>
                    <Text color="#9A82B8" fontSize="md">
                    {props.guestCode}
                    </Text>
                  </Stack>
                  <Text>One Time Visit</Text>
                  {props.oneTimeVisit ? <GrFormCheckmark size="2.0em" /> : <GrFormClose size="2.0em" />}
                  
                </Flex>

                <Flex justify="space-between" align="center">
                  <Stack>
                    <Text color="#7A7A7A" fontSize="sm">
                      Tenant Code
                    </Text>
                    <Text color="#9A82B8" fontSize="md">
                      {props.tenantCode}
                    </Text>
                  </Stack>
                  <Text>Allow Company</Text>
                  {props.allowCompany ? <GrFormCheckmark size="2.0em" /> : <GrFormClose size="2.0em" />}
                </Flex>
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
